@if (ishaveCharQuota) {
  <div class="new-cc-modal">
    <div class="header">
      <h4>TIME to Create a new Character!</h4>
    </div>
    <div class="new-cc-body">
      Redirecting you to Character Creation step.
    </div>
    <div class="btn-wrapper">
      <button type="button" class="btn btn-theme" (click)="closeModal()">Back</button>
      <button type="button" class="btn btn-green" (click)="navigateCharacterCreation()">Proceed</button>
    </div>
  </div>
}

@if (!ishaveCharQuota && !isRetiredContent) {
  <div class="cc-slot-modal">
    <div class="header">
      <h4>Out of Character Slots!</h4>
    </div>
    <div class="cc-slot-body">
      <p>Your account has reached the active character limit.</p>
      <p>Please subscribe to gain more character slots or retire an existing character.</p>
    </div>
    <div class="btn-wrapper">
      <button type="button" class="btn btn-theme" (click)="closeModal()">Back</button>
      <button type="button" class="btn btn-green" (click)="navigateToSubscribe()">Subscribe</button>
    </div>
  </div>
}

@if (!ishaveCharQuota && isRetiredContent) {
  <div class="cc-slot-modal">
    <div class="header">
      <h4>Out of Character Slots!</h4>
    </div>
    <div class="cc-slot-body">
      <p>Your account has reached the retired character limit.</p>
      <p>Please subscribe to gain more character slots.</p>
    </div>
    <div class="btn-wrapper">
      <button type="button" class="btn btn-theme" (click)="closeModal()">Back</button>
      <button type="button" class="btn btn-green" (click)="navigateToSubscribe()">Subscribe</button>
    </div>
  </div>
}